export const service_url = process.env.NODE_ENV === 'production' ? 'https://fastcheckout.sweetecom.com' : 'https://66f7-94-244-17-108.ngrok.io';
export const url = process.env.NODE_ENV === 'production' ? 'https://fastcheckout.sweetecom.com' : window.location.origin;
